import React, { useEffect, useMemo, useState } from "react";
import "../OnlinePortfolio/OnlinePortfolio.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { Pagination } from "swiper/modules";
import { Context } from "../../../../utils/context";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import Common_Multiple_Banner from "../../../common_components/common_multiple_banner/Common_Multiple_Banner";
import { BannersIDS, commonBannerApi } from "../../../../utils/commonBannerApi";
const OnlinePortfolio = () => {
  const { signin, imageUrl } = useContext(Context);

  const [imgSrc, setImgSrc] = useState([]);

  const getBanners = async () => {
    try {
      const res = await commonBannerApi(BannersIDS.HPOnlinePortfolio);
      if (res?.success) {
        setImgSrc(res.data || []);
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    getBanners();
  }, []);

  const imgSrcNew = useMemo(() => imgSrc.map((item) => item?.image), [imgSrc]);



  // const imgSrc = [
  //   "/assets/Images/home/portfolio_banner/img1.png",
  //   "/assets/Images/home/portfolio_banner/img2.png",
  //   "/assets/Images/home/portfolio_banner/img3.png",
  // ];

  return (
    <>
      <section className=" OnlinePortfolio">
        <div className="container">
          <div className="swiper_div">
            <Common_Multiple_Banner
              imgSrc={imgSrcNew}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1.1,
                  spaceBetween: 20,
                },
              }}
              modules={[Pagination]}
              className="mySwiper"
            />
          </div>

          {/* <div className="swiper_div">
            <Swiper
              slidesPerView={1}
              spaceBetween={10}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1.1,
                  spaceBetween: 20,
                },
              }}
              modules={[Pagination]}
              className="mySwiper"
            >
              <SwiperSlide className="slides">
                <div className="banner_main_holder">
                  <div className="banner_holder">
                    <img
                      src="/assets/Images/home/portfolio_banner/img1.png"
                      className="banner_img"
                    />
                  </div>

                  {!signin && (
                    <div className="btn_holder">
                      <div className="button_container">
                        <Link to={"/getotp-jobseeker"}>
                          <button className="btn btn-primary createaccbtn">
                            Create Account
                          </button>
                        </Link>
                        <div className="arrow-icon">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </SwiperSlide>

              <SwiperSlide className="slides">
                <div className="banner_main_holder">
                  <div className="banner_holder">
                    <img
                      src="/assets/Images/home/portfolio_banner/img2.png"
                      className="banner_img"
                    />
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide className="slides">
                <div className="banner_main_holder">
                  <div className="banner_holder">
                    <img
                      src="/assets/Images/home/portfolio_banner/img3.png"
                      className="banner_img"
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div> */}
        </div>

        {/* old code */}
        {/* <div className="container-fluid">
          <div className="row">
            <div className="Banner_OnlinePortfolio">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "assets/Images/banner/back_img_portfoilio.png"
                }
                className="back_img"
                alt="..."
              />
              <div className="upper_content_portfolio row ">
                <div className="col-lg-7 col-md-7 col-12">
                  <div className="info_section">
                    <div>
                    <span className="makeDifference_txt">
                    Create. Connect. Thrive:
                    </span>
                    <br />
                    <span className="onlinePort_txt">
                    Your Portfolio + Millions of Jobs =
                    <br/> <b>Career Success</b>
                    </span>
                    </div>
                    

                    {!signin && (
                      <div className="button-container">
                        <Link to={"/getotp-jobseeker"}>
                          <button className="btn btn-primary createaccbtn">
                            Create Account
                          </button>
                        </Link>
                        <div className="arrow-icon">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-5 col-md-5 col-12">
                  <div className="mx-auto text-center">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "assets/Images/banner/man_img_portfolio.png"
                      }
                      className="portfolio_man_img"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default OnlinePortfolio;
